var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeometry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 1.25006C12.2569 1.25318 12.4868 1.37811 12.624 1.58398L22.624 16.584C22.7062 16.7072 22.75 16.8519 22.75 17C22.75 18.8178 21.2959 20.2617 19.4065 21.2064C17.4722 22.1735 14.8526 22.75 12 22.75C9.14739 22.75 6.52776 22.1735 4.59352 21.2064C2.70415 20.2617 1.25 18.8178 1.25 17C1.25 16.0308 1.66337 15.1679 2.33568 14.4303L11.3866 1.56838C11.529 1.36604 11.7621 1.24694 12.0095 1.25006ZM3.00327 16.0563C2.83259 16.3758 2.75 16.6938 2.75 17C2.75 17.9436 3.53443 18.9998 5.26434 19.8647C6.9494 20.7072 9.32976 21.25 12 21.25C14.6702 21.25 17.0506 20.7072 18.7357 19.8647C20.0178 19.2236 20.7806 18.4775 21.0896 17.75H13C12.0335 17.75 11.25 16.9665 11.25 16V12.7644C8.88544 12.8554 6.78992 13.3725 5.26434 14.1353C4.49786 14.5185 3.91699 14.9393 3.50772 15.3712L3.11335 15.9316C3.08067 15.9781 3.04367 16.0197 3.00327 16.0563ZM20.5986 16.25L12.75 4.47708V16C12.75 16.1381 12.8619 16.25 13 16.25H20.5986ZM11.25 4.36902L5.64676 12.3315C7.24265 11.7188 9.17155 11.3377 11.25 11.2634V4.36902Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/geometry.256f13d2cdec0113178a04da48114013.svg";
export { ForwardRef as ReactComponent };